<template>
  <div
    class="title-block"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      position: relative ? 'relative' : 'static',
      top: `${top}rem`,
      left: `${left}rem`
    }"
  >
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: String,
    height: String,
    relative: {
      type: Boolean,
      default: false
    },
    top: String,
    left: String
  }
};
</script>

<style lang="scss" scoped>
.title-block {
  display: flex;
  //background: #6CC8A0 0% 0% no-repeat padding-box;
  background: #a6cc39 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  color: #fff;
  font: 25px "Kanit", sans-serif;
  letter-spacing: 0;
  align-items: center;
  div {
    margin: auto;
  }
  z-index: 1;
}
</style>
